/* screens/SupportScreen.jsx */
import "./Profile.css";
import BackBtn from "./Shared/BackBtn";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallIcon from "@mui/icons-material/Call";
import { motion, easeOut } from "framer-motion";

export default function SupportScreen(){
  return(
    <motion.div className="pf-wrap" initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.3,
                            ease: easeOut,
                        }}>
      <BackBtn/>
      <h2 className="pf-modal-title" style={{textAlign:"left"}}>Customer Support</h2>

      <div className="pf-supp-card">
        <MailOutlineIcon sx={{color:"#F5A623"}}/>
        <div>
          <div style={{fontWeight:600}}>Email address</div>
          dummymail@example.com
        </div>
      </div>

      <div className="pf-supp-card">
        <CallIcon sx={{color:"#F5A623"}}/>
        <div>
          <div style={{fontWeight:600}}>Phone number</div>
          1234567890
        </div>
      </div>
    </motion.div>
  );
}
